export const updateUnderlyingValue = function (e) {
    if (e.action === undefined) return;
    const me = this;
    if (me.readonly) {
        const skippableAction = e.action === 'itemchange' ||
            e.action === 'add' ||
            e.action === 'remove'
        if (skippableAction) {
            me.dataSource.cancelChanges();
        }
        return;
    }
    if (e.action !== 'itemchange') return; //update underlying value on change when not readonly
    $.each(e.items, (i, d) => {
        // Emptying a numeric editor reports null rather than 0. Normalising it here, where
        // the value is already being written through, means every exit path from a row gets
        // a number without having to look for nulls itself. This replaced a sweep that ran
        // on every Tab keyup and on every document click, once per widget, over every row of
        // every grid: it fired synthetic focusout events, so a press that touched nothing
        // could mark a row dirty and get it saved.
        if (d[e.field] === null) d[e.field] = 0;
        d[me.options.jsonField][e.field] = d[e.field];
    });
};

export const _dataSource = function () {
    const me = this;
    let dataSource = me.dataSource
    if (dataSource) return;
    const {dataSource: newDataSource, staticColumns} = me.options;
    const s = newDataSource.schema;
    s.resourceEntry = me;
    s.model = me._getModel();
    s.parse = me._parse.bind(me);
    const calculatedAggregates = [];
    $.each(staticColumns, (i, sc) => {
        if (!sc.aggregates) return;
        $.each(sc.aggregates, (ai, sca) => calculatedAggregates.push({field: sc.field, aggregate: sca}));
    });
    $.each(me.fieldInfo, (i, fi) => calculatedAggregates.push({field: fi.field, aggregate: 'sum'}));
    newDataSource.aggregate = calculatedAggregates;
    dataSource = kendo.data.DataSource.create(newDataSource);
    dataSource.bind('change', updateUnderlyingValue.bind(me));
    return dataSource;
};

export const _getModel = function () {
    const me = this;
    const readonly = me.readonly;
    const {staticColumns} = me.options;
    const {model} = me.options.dataSource.schema;
    const newFields = {};
    $.each(staticColumns, (i, staticColumn) => {
        if (staticColumn.field === undefined) return;
        const colType = staticColumn.type === 'currency' ? 'number' : staticColumn.type;
        newFields[staticColumn.field] = {
            editable: staticColumn.editable ?? false,
            type: colType ?? 'string'
        };
    });
    $.each(me.fieldInfo, (i, info) => {
        newFields[info.field] = {
            editable: true,
            type: 'number'
        }
    });
    model.rowSum = function () {
        let shouldManualAggregate = false;
        let sum = 0;
        let dataItem = this;
        $.each(me.fieldInfo, (i, info) => {
            let dataAmount = dataItem[info.field];
            if (dataAmount == null) {
                dataAmount = dataItem.Values[info.field];
                shouldManualAggregate = true;
            }
            sum += dataAmount;
        });

        return sum;
    };
    model.fields = $.extend(model.fields, newFields);
    return model;
};

export const _parse = function (response) {
    if (!response) return {};
    const me = this;
    const dataField = me.dataSource.options.schema.data;
    const jsonFieldName = me.options.jsonField;
    const parseItem = function (item) {
        if (item === undefined) {
            item = {};
            item[jsonFieldName] = [];
        }
        $.each(me.fieldInfo, (i, fi) => {
            const fieldName = fi.field;
            const fields = item[jsonFieldName];
            if (fields === undefined || fields === null) item[fieldName] = 0;
            else item[fieldName] = fields[fieldName] ?? 0;
        });
        return item;
    };
    const toProcess = dataField !== undefined ? response[dataField] : response;
    if (typeof toProcess[Symbol.iterator] !== 'function') return parseItem(toProcess);
    for (const item of toProcess) {
        parseItem(item);
    }
    return response;
};
